import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { isTimedComponentValid } from 'src/utils/timedComponent/timedComponentValidator';
import { useSelector } from 'src/store/react';
import {
  selectCandidateOnboardingBanner,
  selectLanguage,
} from 'src/store/selectors';
import { brandToCaseMap } from 'src/config/utils/constants';
import { getBrandFromZone } from 'src/config/utils/getBrandFromZone';
import { useSelectedZone } from 'src/modules/hooks/Locale';

// @ts-expect-error
import qualityCandidateAsset from './static-assets/quality-candidate.png';
// @ts-expect-error
import scanningAsset from './static-assets/scanning.png';
// @ts-expect-error
import sharingAsset from './static-assets/sharing.png';

const useOnboardingBannerContent = (): {
  isCandidateOnboardingBannerValid: boolean;
  externalHelpURL?: string;
  bannerContent: Array<{
    description: string;
    img: string;
  }>;
} => {
  const { t } = useTranslations(translations);
  const language = useSelector(selectLanguage);
  const brand = brandToCaseMap[getBrandFromZone(useSelectedZone())];

  const candidateOnboardingBanner = useSelector(
    selectCandidateOnboardingBanner,
  );

  const isCandidateOnboardingBannerValid = isTimedComponentValid(
    candidateOnboardingBanner?.displayDates,
  );

  return {
    isCandidateOnboardingBannerValid,
    externalHelpURL: candidateOnboardingBanner?.externalHelpURL[language],
    bannerContent: [
      {
        description: t(
          "Know when you're a strong candidate so you can stand out",
        ),
        img: qualityCandidateAsset,
      },
      {
        description: t(
          'Update your { brand } profile easily from your latest resume',
          {
            brand,
          },
        ),
        img: scanningAsset,
      },
      {
        description: t('Choose to share your profile with anyone'),
        img: sharingAsset,
      },
    ],
  };
};

export default useOnboardingBannerContent;
